import { createSelector } from 'reselect';
import { selectInstruments } from './instruments';

export const selectWatchlistInstruments = (state) => state.watchlists.watchlistInstruments;

export const selectWatchlistInstrumentsDetails = createSelector(
  (_, id) => id,
  selectWatchlistInstruments,
  selectInstruments,
  (watchlistId, watchlistInstruments, instruments) => {
    const wli = watchlistInstruments[watchlistId];
    if (wli) {
      return wli.map((i) => instruments[i.instrumentId]);
    }

    return [];
  }
);
